export default __webpack_public_path__ + "static/media/tasks.c53cb2a1.svg";